import React from 'react';

const SpeakerIconExp = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M1.99902 2V10M2.04883 14V14.1L1.94922 14.1002V14H2.04883Z" stroke="#3249D7" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  );
};

export default SpeakerIconExp;
